import React from 'react';
import {Button, Flex} from 'antd';
import {useModel} from "@@/exports";
import {SyncOutlined} from "@ant-design/icons";

const SenderRender = (props) => {
  const {robot} = props;
  const {setRobot} = useModel('copilot');

  return (
    <Flex gap="small" style={{width: '100%'}}>
      <Flex gap="small" style={{width: '100%'}}>
        <Button
          type={'primary'}
          onClick={() => {
            setRobot({...robot, status: 'START'});
          }}
          block={true}
          loading={robot?.status !== 'UNSTART' ? {icon: <SyncOutlined spin/>}:false}>
          {robot?.status !== 'UNSTART' ? '运行中' : '开始'}
        </Button>
      </Flex>
      {/*<Flex gap="small" style={{ width: '100%' }}><Button disabled={robot?.status === 'UNSTART' || robot?.status === 'END'} block={true} color={'orange'} variant="solid">暂停</Button></Flex>*/}
      {/*<Flex gap="small" style={{ width: '100%' }}><Button disabled={robot?.status === 'UNSTART' || robot?.status === 'END'} block={true} type={'primary'} danger>停止</Button></Flex>*/}
    </Flex>
  );
};
export default SenderRender;
